import {
  Box,
  Container,
  Typography,
  Grid,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { psiTokens } from '../../theme/psiTheme';
import { useLanguage } from '../../contexts/LanguageContext';

const stats = [
  { valueKey: 'stats.years.value', labelKey: 'stats.years.label' },
  { valueKey: 'stats.bilingual.value', labelKey: 'stats.bilingual.label' },
  { valueKey: 'stats.formats.value', labelKey: 'stats.formats.label' },
  { valueKey: 'stats.availability.value', labelKey: 'stats.availability.label' },
];

export default function StatsBar() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { t } = useLanguage();

  return (
    <Box
      sx={{
        backgroundColor: psiTokens.text.primary,
        color: '#ffffff',
        py: 5,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={isMobile ? 2 : 4} alignItems="center">
          {stats.map((stat) => (
            <Grid item xs={6} sm={6} md={3} key={stat.valueKey} sx={{ display: 'flex' }}>
              <Box
                sx={{
                  textAlign: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  width: '100%',
                }}
              >
                <Typography
                  sx={{
                    fontSize: isMobile ? '18px' : '22px',
                    fontWeight: 700,
                    color: '#ffffff',
                    marginBottom: 1,
                    lineHeight: 1.3,
                  }}
                >
                  {t(stat.valueKey)}
                </Typography>
                <Typography
                  sx={{
                    fontSize: '11px',
                    fontWeight: 600,
                    letterSpacing: '0.12em',
                    textTransform: 'uppercase',
                    color: psiTokens.primary.light,
                  }}
                >
                  {t(stat.labelKey)}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
